import { useQuery } from '@tanstack/react-query';
import { getCustomerReviews } from '../../api/strapi';

const CUSTOMER_REVIEWS_FLAG = 'CUSTOMER_REVIEWS';

const useCustomerReviews = () =>
  useQuery([CUSTOMER_REVIEWS_FLAG], () => getCustomerReviews(), {
    cacheTime: 1000 * 60 * 60,
    select: res => res.data?.data ?? undefined,
    staleTime: 1000 * 60 * 60,
    retry: 1,
    retryOnMount: false,
    refetchOnWindowFocus: false
  });

export default useCustomerReviews;
